<template>
  <div class="flex flex-col sm:flex-row border-2 border-solid border-black">
    <div class="formation-basics border-b-2 sm:border-b-0 sm:border-r-2 w-full sm:w-64 h-24 sm:h-48">
      <p>{{date}}</p>
      <p class="font-bold">{{type}}</p>
    </div>
    <div class="formation-description py-5 sm:py-0">
      <p class="font-bold text-xl"><slot></slot></p>
      <p>{{institute}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormationItem',
  props: {
    date: String,
    type: String,
    institute: String
  }
}
</script>

<style scoped>
.formation-basics {
  @apply flex flex-col justify-center text-center border-solid border-black;
}
.formation-description {
  @apply flex flex-col justify-center mx-5;
}
</style>
